import {
  Field,
  LinkField,
  Placeholder,
  Text,
  useSitecoreContext,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames/bind';
import React from 'react';

import type { ComponentProps } from 'lib/component-props';

import styles from './Tab.module.scss';

type TabFields = {
  name: Field<string>;
  order?: Field<number>;
  externalLink?: LinkField;
};

export type TabProps = ComponentProps & {
  fields: TabFields;
};

const cx = classNames.bind(styles);

const Tab = (props: TabProps): JSX.Element => {
  const { fields, rendering } = props;
  const { name } = fields;
  const { uid } = rendering;

  const { sitecoreContext } = useSitecoreContext();
  const { pageEditing } = sitecoreContext;

  return (
    <section
      className={cx({ tabpanel: true, 'page-editing': pageEditing })}
      id={`tabpanel-${uid}`}
      aria-labelledby={`tab-${uid}`}
    >
      {pageEditing && <Text className={cx('font-style-xl')} field={name} tag="h3" />}
      <Placeholder key={uid} name="hp-tabpanel" rendering={rendering} />
    </section>
  );
};

export default withDatasourceCheck()<TabProps>(Tab);
